import { ModalInput } from "components/atoms/input/modal/ModalInput";
import { Text } from "components/atoms/text/Text";
import AccountId from "components/atoms/text/labels/AccountId";
import { LEVEL_TYPE } from "api/interfaces/commonInterface.interface";
import styled from "styled-components";
import { FLEX } from "styles/flex";
import { COLORS } from "styles/colors";

type Props = {
  accountName: string;
  accountNumber: string;
  accountLevel: LEVEL_TYPE;
};

export default function SubscriptionOrgLabel(props: Props): JSX.Element {
  return (
    <OrgWrapper>
      <ModalInput label="Organization" noBold>
        <div className="org-inner">
          <Text bold>{props.accountName}</Text>
          <AccountId
            accountId={props.accountNumber}
            level={props.accountLevel}
          />
        </div>
      </ModalInput>
    </OrgWrapper>
  );
}
const OrgWrapper = styled.div`
  width: 100%;
  padding-bottom: 10px;

  .modal-input-label-title {
    color: ${COLORS.BUTTONS1};
  }
  .org-inner {
    ${FLEX.FlexStartCenter};
    gap: 8px;

    .account-id-label {
      padding: 5px;
    }
  }
`;
